<template>
    <div class="flex flex-row justify-start">
        <a href="#"
            class="flex flex-row items-center py-2 px-4 my-2 mr-2 border border-gray-300 text-gray-500 rounded-md shadow-sm hover:border-gray-300 hover:text-gray-400"
            :class="{'border-blue-500 hover:border-blue-400 text-blue-500 hover:text-blue-400 pl-2 pr-2':option.value==checked_value, 'ml-0':index==0, 'ml-2':index > 0}"
            @click.prevent="select(option.value)"
            v-for="(option, index) in options"
            :key="'option_'+index"
            :title="option.label" >
            <vue-feather type="check"
                v-if="option.value==checked_value"
                class="h-4 w-4 mr-1"
                :class="{'hidden':option.value!=checked_value}" />
            {{ option.label }}
        </a>
    </div>
</template>




<script>
export default {
    emits: ['update'],
    props: {
        checked: {
            type: String,
            default: "",
        },
        options: {
            type: Array,
            default: [],
        },
    },
    data() {
        return {
            checked_value: this.checked
        }
    },
    computed: {

    },
    methods: {
        select: function(value) {
            this.checked_value = value
            this.$emit("update", this.checked_value);
        }

    },
}
</script>
<style scoped>

</style>
